export default "/images/equipment_placeholder.png?e81dbb0b6465190fbb5b6a632345529b";